export default {
  EN_ATTENTE: 0,
  VALIDER: 1,
  REFUSER: 2,
  OFFRE: 3,
};
